import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React from 'react';
import { capitalize } from '@material-ui/core/utils';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  return {
    colorInfo: {
      color: theme.palette.info.main
    },
    colorSuccess: {
      color: theme.palette.success.main
    },
    colorWarning: {
      color: theme.palette.warning.main
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
});
export var MCircularProgress = function MCircularProgress(_a) {
  var _a$color = _a.color,
      color = _a$color === void 0 ? 'primary' : _a$color,
      className = _a.className,
      other = __rest(_a, ["color", "className"]);

  var classes = useStyles();

  if (color === 'inherit' || color === 'primary' || color === 'secondary') {
    return React.createElement(CircularProgress, Object.assign({
      color: color,
      className: className
    }, other));
  }

  return React.createElement(CircularProgress, Object.assign({
    className: clsx(_defineProperty({}, classes["color".concat(capitalize(color))], color), className)
  }, other));
};